import { ReactNode, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "@/contexts/AuthContext";
import { Loader2 } from "lucide-react";

interface ProtectedRouteProps {
  children: ReactNode;
  redirectTo?: string;
}

export function ProtectedRoute({ children, redirectTo }: ProtectedRouteProps) {
  const { user, loading } = useAuth();
  const navigate = useNavigate();

  const currentPath = typeof window !== "undefined" ? window.location.pathname + window.location.search : "/";
  const loginUrl = redirectTo || `/login?redirect=${encodeURIComponent(currentPath)}`;

  useEffect(() => {
    if (!loading && !user) {
      navigate(loginUrl, { replace: true });
    }
  }, [loading, user, navigate, loginUrl]);

  if (loading) {
    return (
      <div className="min-h-screen bg-background flex items-center justify-center">
        <div className="text-center">
          <Loader2 className="h-8 w-8 animate-spin mx-auto mb-4 text-primary" />
          <p className="text-muted-foreground text-sm">Chargement...</p>
        </div>
      </div>
    );
  }

  if (!user) {
    return null;
  }

  return <>{children}</>;
}
